import styled from 'styled-components';

export const ExpertPageContainer = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 25px;
`;
